<template>
  <div class="timeserie">
    <div class="timeserie__dida">
      <SelectionLabel
        v-if="sourceConfig"
        :withUom="true"
        :withGeoArea="sourceConfig.geoAreas"
        :extraSource="extraSource"
        type="map"
      ></SelectionLabel>
    </div>
    <div class="timeserie__chart" v-if="timeSerie">
      <!--[NB] In TVAAreaChart i changed a bit  components grids ( in order to stop the line at the value dot) 
      and in mixin global the method ticksX in order to calculate the ticksX 
      BioFuels chart is still ugly becaus has different year intervals and 2019 overlaps with 2020...
      Also when SOLAR is selected for "Russia and centralAsia" the chart is not displayed correctly because all data are zeros,
       don't know if it's because of my modification or the chart
      -->
      <TvaAreaChart :config="config" :data="timeSerie"></TvaAreaChart>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SelectionLabel from "@/components/widgets/SelectionLabel.vue";
import TvaAreaChart from "@/components/widgets/areaChart/TvaAreaChart.vue";

export default {
  name: "TimeSerie",
  components: {
    SelectionLabel,
    TvaAreaChart,
  },
  data() {
    return {
      config: {
        globalUnitSymbol: "",
        globalDecimals: 0,
        globalLanguage: "en-US",
        globalFixedWidth: null,
        globalFixedHeight: null,
        globalMarginTop: 50,
        globalMarginRight: 20,
        globalMarginBottom: 0,
        globalMarginLeft: 20,

        gridXStrokeColor: ["var(--primary-yellow_30)", "var(--primary-yellow)"],

        gridXStrokeWidth: [],
        gridXStrokeDash: "0",
        gridYStrokeColor: "#fff",
        gridYStrokeWidth: 0,
        gridYBaselineStrokeWidth: 0,
        gridYStrokeDash: "0",

        xAxisHeight: 20,
        xAxisPosition: "bottom",
        xAxisTicksAmount: null,
        xAxisType: "string",
        xAxisTickHeight: 0,
        xAxisTickStrokeColor: "red",
        xAxisTickStrokeWidth: 0,
        xAxisFontSize: 12,
        xAxisLabelXOffset: -5,
        xAxisLabelYOffset: 0,

        yAxisWidth: 10,
        yAxisPosition: "left",
        yAxisTicksAmount: 5,
        yAxisCurve: "curveLinear",
        yAxisScale: "linear",
        yAxisTickWidth: 3,
        yAxisTickStrokeColor: "#fff",
        yAxisTickStrokeWidth: 1,
        yAxisFontSize: 12,
        yAxisLabelAnchor: "end",
        yAxisLabelXOffset: -5,
        yAxisLabelYOffset: 0,
        legendHeight: 22,
        legendPosition: "bottom",
        legendFontSize: 14,
        series: [
          {
            key: "QTY",
            label: "",
            colorPrimary: "var(--white_04)",
            colorSecondary: "",
            strokeWidth: 1,
            fontSize: 12,
            dotSize: 3,
            dotColor: "var(--primary-yellow)",
          },
        ],
        xAxis: "YEAR",
      },
    };
  },
  computed: {
    extraSource() {
      if (this.sourceConfig) {
        const index = this.sourceConfig.dataSource.findIndex(
          (el) => el.extraSource
        );
        if (index !== -1) {
          const extra = this.sourceConfig.dataSource[index];
          if (
            extra.dataType == this.dataType &&
            ((!!extra.exceptions &&
              extra.exceptions.indexOf(this.geoArea) !== -1) ||
              !extra.exceptions)
          )
            return extra.extraSource;
        }
      }
      return null;
    },
    ...mapGetters({
      timeSerie: "data/getTimeSerie",
      sourceConfig: "ui/currentSourceConfig",
      dataType: "ui/dataType",
      geoArea: "ui/geoArea",
    }),
  },
};
</script>

<style lang="scss" scoped>
.timeserie {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-right: $white-border;
  padding-right: 1.3vw;
  padding-left: 0.7vw;

  &__dida {
    padding: toRem(15) toRem(30);
    width: 100%;
  }

  &__chart {
    width: 100%;
    height: 100%;
  }
}

.mobile {
  .timeserie {
    height: 48.9vh;
    padding-left: 4.8vw;
    padding-right: 19.5vw;
    &__dida {
      padding: 6.8vh 0 0 10vw;
    }
    &__chart {
      padding-left: 5vw;
    }
  }
}

.tablet {
  .timeserie {
    padding-left: 5.1vw;
    padding-right: 9vw;
    &__dida {
      padding: 1.66vh 5vw 0 0;
    }
    &__chart {
      padding-left: 2.5vw;
    }
  }
}
</style>
